import React, { useEffect } from "react";
import ForgotPassword from "./Content";
import AuthLayout from "../../../components/layout/AuthLayout";
import { getDomainConfig } from "../../../utils/DomainsHelper";
import { updateAppHead } from "../../../utils/general";


const ForgotPasswordPage = () => {
  // Initialize directly from domain config to avoid empty-state flash (improves LCP)
  const domainConfig = getDomainConfig();

  useEffect(() => {
    updateAppHead({
      title: domainConfig.title,
      favicon: domainConfig.favicon,
    });
  }, []);

  return (
    <AuthLayout
      LeftComponent={ForgotPassword}
      rightBgImage={domainConfig.banner}
      logoImage={domainConfig.logo}
    />
  );
};

export default ForgotPasswordPage;